import styled from 'styled-components';
import { transitionCurveMotion, stylesNoSelect } from 'Constants';

const TextDetailsDetail = styled.div`
	/*flex: 0 auto;*/
`;

export default TextDetailsDetail;